export const DEPARTMENT_TABLE_HEAD = [
  { id: 'id', label: 'department.id', alignCenter: true },
  { id: 'name', label: 'department.name', alignRight: false },
  { id: 'description', label: 'department.description', alignRight: false },
  { id: 'users', label: 'department.users', alignRight: false },
  { id: 'tickets', label: 'department.tickets', alignCenter: false },
  { id: 'options', label: 'department.options', sticky: true },
];
